export default __webpack_public_path__ + "static/media/cathedral.9386559b.jpg";